import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { MessageCircle, Instagram, Facebook, Phone, Mail, Share2, ArrowLeft, Sparkles } from "lucide-react";
import api, { fileUrl, img } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export default function ArtisanDetail() {
  const { slug } = useParams();
  const { t, L } = useLang();
  const [a, setA] = useState(null);

  useEffect(() => {
    api.get(`/artisans/${slug}`).then((r) => setA(r.data)).catch(() => setA(false));
  }, [slug]);

  if (a === false) return <div className="max-w-3xl mx-auto px-6 py-20 font-mono-fk">Not found.</div>;
  if (!a) return <div className="max-w-3xl mx-auto px-6 py-20 font-mono-fk animate-pulse">Loading…</div>;

  const share = () => {
    const url = window.location.href;
    if (navigator.share) navigator.share({ title: L(a.name_zh, a.name_en), url }).catch(() => {});
    else { navigator.clipboard.writeText(url); toast.success(L("链接已复制", "Link copied")); }
  };

  const social = a.social || {};

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
      <Link to="/artisans" className="font-mono-fk text-sm inline-flex items-center gap-1 mb-6 hover:underline"><ArrowLeft size={15} /> {t("artisans_title")}</Link>

      <div className="grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          {a.photos?.length > 0 ? (
            <div className="grid grid-cols-2 gap-3">
              <img src={fileUrl(a.photos[0])} alt="" className="col-span-2 rounded-2xl fk-border-thick w-full h-72 object-cover" />
              {a.photos.slice(1, 5).map((p, i) => <img key={i} src={fileUrl(p)} alt="" className="rounded-xl fk-border h-36 w-full object-cover" />)}
            </div>
          ) : (
            <img src={img("")} alt="" className="rounded-2xl fk-border-thick w-full h-72 object-cover" />
          )}

          <h1 className="font-display text-4xl sm:text-5xl mt-8">{L(a.name_zh, a.name_en)}</h1>
          <span className="font-mono-fk text-xs fk-border rounded-full px-3 py-1 bg-[#00E5FF] inline-flex items-center gap-1 mt-3"><Sparkles size={12} /> {a.category || t("artisans_title")}</span>
          <p className="mt-5 text-black/70 leading-relaxed text-lg">{L(a.bio_zh, a.bio_en)}</p>
        </div>

        <aside className="bg-white fk-border-thick rounded-2xl p-6 fk-shadow h-fit space-y-3">
          <div className="font-mono-fk text-xs tracking-widest text-black/50">{t("contact")}</div>
          {a.contact_phone && <a href={`tel:${a.contact_phone}`} className="flex items-center gap-2 hover:text-[#FF5757]"><Phone size={16} /> {a.contact_phone}</a>}
          {a.contact_email && <a href={`mailto:${a.contact_email}`} className="flex items-center gap-2 hover:text-[#FF5757] break-all"><Mail size={16} /> {a.contact_email}</a>}
          {social.whatsapp && <a href={`https://wa.me/${social.whatsapp}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#25D366]"><MessageCircle size={16} /> WhatsApp</a>}
          {social.instagram && <a href={social.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#FF5757]"><Instagram size={16} /> Instagram</a>}
          {social.facebook && <a href={social.facebook} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#1877F2]"><Facebook size={16} /> Facebook</a>}
          <button onClick={share} data-testid="artisan-share" className="w-full mt-2 flex items-center justify-center gap-2 fk-border rounded-full px-4 py-2.5 font-semibold bg-[#FFD93D] fk-lift"><Share2 size={15} /> {t("share")}</button>
        </aside>
      </div>
    </div>
  );
}
